{
  "actions": {
    "add": "Lägg till",
    "open": "Öppna",
    "openType": "Öppna {{type, lowercase}}",
    "edit": "Redigera",
    "remove": "Ta bort",
    "abort": "Avbryt",
    "close": "Stäng",
    "clear": "Rensa",
    "create": "Skapa",
    "createNew": "Skapa ny {{documentType}}",
    "search": "Sök",
    "sort": "Sortera",
    "sortBy": "Sortera efter {{label}}",
    "presetSort": "Förinställd sortering",
    "grouping": "Välj gruppering",
    "nogrouping": "Ingen gruppering",
    "group": "Gruppera",
    "copy": "Kopiera",
    "confirm": "Klar",
    "markAsDone": "Klarmarkera",
    "move": "Flytta",
    "yes": "Ja",
    "no": "Nej",
    "approve": "Godkänn",
    "saveType": "Spara {{type}}",
    "save": "Spara",
    "publish": "Publicera"
  },
  "misc": {
    "unknown": "okänd",
    "user": "användare",
    "numberOf": "Antal",
    "from": "Från",
    "new": "Ny",
    "selected": "valda",
    "since": "sedan",
    "missing": "saknas",
    "loading": "Laddar...",
    "titleMissing": "Titel saknas",
    "fetchingSession": "Hämtar session...",
    "fetchingUserData": "Hämtar användardata...",
    "headingAndContent": "Rubrik och innehåll",
    "markedAsCancelled": "Markerad som inställd",
    "error": "Fel",
    "selectTime": "Välj tid",
    "selectDates": "Välj datum",
    "searching": "Söker...",
    "nothingFound": "Ingenting hittades"
  },
  "advancedSearch": {
    "title": "Avancerad sökning",
    "structured": "Strukturerad",
    "querySyntax": "Söksyntax",
    "query": "Sökning",
    "searchIn": "Sök i",
    "matchType": "Matchningstyp",
    "words": "Ord",
    "exactPhrase": "Exakt fras",
    "requireAllTerms": "Kräv alla termer (AND)",
    "fuzzyMatching": "Fuzzy-matchning",
    "fuzzyAuto": "Auto",
    "fuzzyEdit1": "~1 ändring",
    "fuzzyEdit2": "~2 ändringar",
    "prefixLength": "Lås första N tecken",
    "boost": "Relevansökning",
    "dateRange": "Datumintervall",
    "fieldExists": "Fält finns/saknas",
    "exists": "Har",
    "missing": "Saknas",
    "moreOptions": "Fler alternativ",
    "cancel": "Avbryt",
    "search": "Sök",
    "searchTerms": "Söktermer...",
    "namePlaceholder": "Namnge sökningen (valfritt)",
    "querySyntaxPlaceholder": "title:\"ukraine\" AND content:crisis*",
    "syntaxReference": "Syntaxreferens",
    "syntaxOperators": "Operatorer",
    "syntaxOperatorsValue": "AND, OR, NOT",
    "syntaxPhrase": "Fras",
    "syntaxPhraseValue": "\"exakt fras\"",
    "syntaxWildcard": "Jokertecken",
    "syntaxWildcardValue": "ukrai* , cr?sis",
    "syntaxFuzzy": "Fuzzy",
    "syntaxFuzzyValue": "ord~2",
    "syntaxGrouping": "Gruppering",
    "syntaxGroupingValue": "(a OR b) AND c",
    "syntaxFieldSearch": "Fältsökning",
    "syntaxFieldSearchValue": "fält:värde",
    "syntaxAvailableFields": "Tillgängliga fält",
    "hints": {
      "searchIn": "Välj vilka dokumentfält som ska genomsökas",
      "words": "Hittar det bäst matchande fältet för dina söktermer",
      "exactPhrase": "Kräver att orden förekommer i exakt ordning",
      "requireAllTerms": "Alla söktermer måste finnas med (standard är valfri term)",
      "fuzzyMatching": "Tillåter ungefärliga matchningar, t.ex. stavfel",
      "fuzzyDisabledForPhrase": "Fuzzy-matchning är inte tillgängligt för exakt fras-sökning",
      "fuzzyEdits": "Antal teckenändringar som tillåts per ord",
      "prefixLength": "Antal inledande tecken som måste matcha exakt innan fuzzy-matchning aktiveras",
      "boost": "Multiplikator för relevanspoäng — högre värden rankar matchningar högre",
      "fieldExists": "Filtrera dokument efter om ett fält har innehåll eller är tomt",
      "searchInDisabledForMissing": "Går inte att söka i ett fält som måste saknas"
    },
    "notices": {
      "dateRangeNotConverted": "Datumintervallet ingår inte i söksyntaxen och används inte."
    },
    "modeChange": {
      "title": "Byt sökläge?",
      "description": "Söksyntaxen kan inte visas i formuläret. Byter du läge kasseras den och du börjar om med en tom sökning. Sökningen som redan används påverkas inte.",
      "confirm": "Byt läge"
    },
    "badge": {
      "fuzzy": "Fuzzy (~{{edits}})",
      "fuzzyAuto": "Fuzzy (auto)",
      "fields": "Fält: {{fields}}",
      "boost": "Boost: {{boost}}x"
    },
    "fields": {
      "title": "Titel",
      "content": "Innehåll",
      "slugline": "Slugg",
      "description": "Beskrivning",
      "assignment": "Uppdrag",
      "subject": "Ämne",
      "table": "Tabell"
    }
  }
}
